import React from "react";
import "./AutoGradePopup.less";

export default class AutoGradePopup extends React.Component {


    static defaultProps = {
        leftButtonText: null,
        rightButtonText: null,
        onLeftClick: () => {
        },
        onRightClick: () => {
        },
    };

    render() {

        return (<div className="autograde_skip_popup">
            <div>
                {this.props.children}
                <div className="autograde_skip_popup__buttons">
                    <button onClick={this.props.onLeftClick}>{this.props.leftButtonText}</button>
                    <button onClick={this.props.onRightClick}>{this.props.rightButtonText}</button>
                </div>
            </div>
        </div>);

    }

}
